import { FC, FormEvent } from 'react';
import React, { useEffect, useState } from 'react';
import classes from './Login.module.scss';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'actions/auth-actions';
import { Alert, Box, Button, FormControl, TextField } from '@mui/material';
import { useAppSelector } from 'setup/store';
import LoadingSpinner from 'components/lib/UI/loadingSpinner/LoadingSpinner';
import { useAppActions } from 'actions/app-actions';
import { ChangePasswordPayload, SnackbarType } from 'common/interfaces';
import UICard from 'components/lib/card/UICard';
type ChangePasswordFormProps = {};

const ChangePasswordForm: FC<ChangePasswordFormProps> = ({}) => {
  const { changePassword, setError, resetAuthError } = useAuthContext();
  const { showSnackBar } = useAppActions();
  const [loginData, setLoginData] = useState({} as ChangePasswordPayload);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const error = useAppSelector((state) => state.authReducer.error);
  const loading = useAppSelector((state) => state.authReducer.loading);
  const navigate = useNavigate();

  useEffect(() => {
    resetAuthError();
  }, []);

  const validate = () => {
    let isValid = true;
    console.log('validate: ', loginData);
    const errs = errors ? { ...errors } : {};

    if (!loginData?.currentPassword) {
      isValid = false;
      errs['currentPassword'] = 'Current password is required.';
    } else if (errs['currentPassword']) {
      delete errs['currentPassword'];
    }

    if (!loginData?.password) {
      isValid = false;
      errs['password'] = 'Password is required.';
    } else if (errs['password']) {
      delete errs['password'];
    }

    if (!loginData?.confirmPassword) {
      isValid = false;
      errs['confirmPassword'] = 'Please confirm your password';
    } else if (loginData.password !== loginData.confirmPassword) {
      isValid = false;
      errs['confirmPassword'] = 'Password and Confirm password should be same';
    } else if (errs['confirmPassword']) {
      delete errs['confirmPassword'];
    }

    setErrors(errs);
    return isValid;
  };
  const _handleContinue = async (event: FormEvent) => {
    event.preventDefault();
    const isValid = validate();
    if (isValid) {
      const resp = await changePassword(loginData);
      if (resp) {
        showSnackBar(SnackbarType.SUCCESS, 'Password changed successfully');
        navigate(-1);
      }
    }
  };

  const _handleInputChanged = (text: string, key: string) => {
    console.log('Login:username::', text);
    const tempData = { ...loginData, [key]: text };
    setLoginData(tempData);
  };

  useEffect(() => {
    if (loginData) {
      validate();
    }
  }, [loginData]);

  const _handleCancel = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1.5, width: '50ch' },
          '& .select': { m: 1.5, width: '50ch' },
          '& .selectLabel': { m: 1.5 },
          '& .MuiButton-root': { m: 1.5 },
          //   '& .MuiSelect-root': { m: 1, width: '30ch' },
        }}
        noValidate
        autoComplete="off"
      >
        <UICard title="">
          <FormControl fullWidth>
            <TextField
              fullWidth
              type="password"
              error={errors && errors['currentPassword']?.length > 0 ? true : false}
              id="outlined-error-helper-text"
              label="Current Password"
              value={loginData.currentPassword}
              helperText={errors['currentPassword'] || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                _handleInputChanged(event.target.value, 'currentPassword');
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              fullWidth
              type="password"
              error={errors && errors['password']?.length > 0 ? true : false}
              id="outlined-error-helper-text"
              label="Password"
              value={loginData.password}
              helperText={errors['password'] || ''}
              className="rowItem"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                _handleInputChanged(event.target.value, 'password');
              }}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              fullWidth
              type="password"
              error={errors && errors['confirmPassword']?.length > 0 ? true : false}
              id="outlined-error-helper-text"
              label="Confirm Password"
              value={loginData.confirmPassword}
              helperText={errors['confirmPassword'] || ''}
              className="rowItem"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                _handleInputChanged(event.target.value, 'confirmPassword');
              }}
            />
          </FormControl>
          {error ? (
            <FormControl fullWidth>
              <Alert severity="error" style={{ marginBottom: '10px' }}>
                {error.msg}
              </Alert>
            </FormControl>
          ) : null}

          <Button variant="contained" onClick={_handleContinue} size="large" className={classes.btn} type="submit">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {loading ? <LoadingSpinner size="small" style={{ marginRight: '10px' }} /> : null} Submit
            </Box>
          </Button>
          <Button disabled={loading} variant="contained" onClick={_handleCancel} loading={loading} color="error">
            Cancel
          </Button>
        </UICard>
      </Box>
    </Box>
  );
};

export default ChangePasswordForm;
